import React from 'react';
import { useSelector } from 'react-redux';
import FormSelect from 'shared/components/selects/FormSelect';
import { selectIsStatesLoading, selectStateCodes } from 'store/entities/scaZone/selectors';

import { IFormSelect } from './model';
import { IFormFieldProps } from '../formFields/models';

export interface IStateCodeSelectProps extends IFormFieldProps, IFormSelect {}

export function StateCodeSelect({
    ...props
}: IStateCodeSelectProps) {
    const usStateCodes = useSelector(selectStateCodes);
    const isStatesLoading = useSelector(selectIsStatesLoading);

    return (
        <FormSelect
            {...props}
            useIdValue
            getKey={(code: string) => code}
            getText={(code: string) => code}
            options={usStateCodes}
            isLoading={isStatesLoading}
        />
    );
}
